import * as React from "react";
import {Button, Tooltip} from "@mui/material";
import {ContentPasteGoOutlined} from "@mui/icons-material";
import useDrive from "../../hooks/useDrive";
import {ACTIONS} from "../DriveRow/driveRowConst";
import FileService from "../../services/FileService";
import DriveService from "../../services/DriveService";
import useNotification from "../../hooks/useNotification";
import {DRIVE_TYPES, UPLOAD_STATUS} from "../../config/appConst";

export default function FileAndFolderCopy() {
  const {copyPath, setCopyPath, CurrentDrive, changeCurrentDrive, changeUploadStatus} = useDrive();
  const {addNotification} = useNotification();

  const paste = async () => {
    const {type, sourceDrive} = copyPath;
    if (sourceDrive !== CurrentDrive.driveType) {
      addNotification({type: "error", message: "Cannot paste across drive types"});
      return;
    }
    let title = "";
    switch (type) {
      case ACTIONS.FILE_COPY:    changeUploadStatus(UPLOAD_STATUS.FILE_COPPING);   title = "File copied";   await fileCpMv({...copyPath, move: 0}); break;
      case ACTIONS.FILE_MOVE:    changeUploadStatus(UPLOAD_STATUS.FILE_MOVING);    title = "File moved";    await fileCpMv({...copyPath, move: 1}); break;
      case ACTIONS.FOLDER_COPY:  changeUploadStatus(UPLOAD_STATUS.FOLDER_COPPING); title = "Folder copied"; await folderCpMv({...copyPath, move: 0}); break;
      case ACTIONS.FOLDER_MOVE:  changeUploadStatus(UPLOAD_STATUS.FOLDER_MOVING);  title = "Folder moved";  await folderCpMv({...copyPath, move: 1}); break;
      default: break;
    }
    addNotification({type: "success", message: title});
    changeUploadStatus(UPLOAD_STATUS.DONE);
    const drive = await DriveService.getFileTree(CurrentDrive.parent, CurrentDrive.driveType);
    if (CurrentDrive.driveType === DRIVE_TYPES.SHARED)
      changeCurrentDrive({...CurrentDrive, drive: {}, sharedDrive: drive});
    else
      changeCurrentDrive({...CurrentDrive, drive, sharedDrive: {}});
    setCopyPath({});
  };

  const fileCpMv = async ({path, name, move}) => {
    const file_name     = `${path}/${name}`;
    const file_name_new = `${CurrentDrive.parent}/${name}`;
    await FileService.copy({file_name, file_name_new, move, driveType: CurrentDrive.driveType});
    setCopyPath({});
  };

  const folderCpMv = async ({path, name, move}) => {
    const folder     = `${path}/${name}`;
    const folder_new = CurrentDrive.parent;
    await DriveService.copy({folder, folder_new, move, driveType: CurrentDrive.driveType});
    setCopyPath({});
  };

  if (!copyPath?.name) return null;

  return (
    <Tooltip title={`Paste "${copyPath.name}" into this folder`} arrow>
      <Button
        variant="outlined" size="small"
        startIcon={<ContentPasteGoOutlined sx={{fontSize: 16}} />}
        onClick={paste}
        sx={{
          height: 34, fontSize: "13px",
          borderColor: "rgba(232,88,120,0.35)",
          color: "#e85878",
          "&:hover": { borderColor: "#e85878", background: "rgba(232,88,120,0.07)" },
        }}
      >
        Paste here
      </Button>
    </Tooltip>
  );
}
